import React, { FC } from "react";
import styled from "styled-components";
import { ExternalLink } from "../link/ExternalLink";
import { colors } from "../../styles/variables";

const StyledDisclaimer = styled.div`
  width: 100%;
  font-size: 12px;
  color: ${colors.gray};
`;

const StyledExternalLink = styled(ExternalLink)`
  color: ${({ theme }) => theme.color.primary};
  text-decoration: underline;
`;

interface DisclaimerProps {
  action: string;
  termsUrl?: string;
  privacyUrl?: string;
  fallbackUrl?: string;
}

export const Disclaimer: FC<DisclaimerProps> = ({
  action,
  termsUrl,
  privacyUrl,
  fallbackUrl = "",
}) => {
  return (
    <StyledDisclaimer>
      By clicking &lsquo;{action}&lsquo;, you are indicating that you have read
      and agreed to the{" "}
      <StyledExternalLink href={termsUrl || `${fallbackUrl}/terms`}>
        Terms of Service
      </StyledExternalLink>{" "}
      and{" "}
      <StyledExternalLink href={privacyUrl || `${fallbackUrl}/privacy`}>
        Privacy Policy
      </StyledExternalLink>
      .
    </StyledDisclaimer>
  );
};
